<template>
    <section class="Section WhiteSnow">
            <div class="Container">
				<div class="BoxWide">
                    <h5>Storico interventi di manutenzione</h5>
					<div class="TabellaGenerale"> 
						<table width="100%" border="0" cellspacing="0" cellpadding="0">
							<tbody>
								<tr>
                                    <th scope="col">Codice Intervento</th>
									<th scope="col">Attività</th>
                                    <th scope="col">Note Intervento</th>
                                    <th scope="col">Esito</th>
                                    <th scope="col">Data</th>
                                    <th scope="col"> Tipo Intervento</th>
								</tr>
								<!-- Inizio repeater -->
                                    <RigaGrigliaStoricoInterventi v-for="(intervento,index) in this.listaStoricoInterventiManutenzioneShow" :key="index" :rigaIntervento="intervento" :index="index"></RigaGrigliaStoricoInterventi>
								<!-- Fine repeater -->
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</section>
</template>

<script>

import RigaGrigliaStoricoInterventi from "@/components/RigaGrigliaStoricoIntEntita.vue";


export default {
    name: "GrigliaStoricoIntEntita",
    data(){
        return {
            listaStoricoInterventiManutenzioneShow : null
        }
    },

    components:{
        RigaGrigliaStoricoInterventi
    },

    props:{
        listaStoricoInterventiManutenzione: Array
    },
    
    watch:{
        listaStoricoInterventiManutenzione: function(newValue){
            this.listaStoricoInterventiManutenzioneShow = newValue;
        }
    }
}
</script>
